import React, { useEffect } from 'react'
import scrollToTop from '../helpers/scrollToTop'
import bannerImage from '../images/banner-image.jpg'
import maria from '../images/maria.jpg'
import lara from '../images/lara.jpg'
import elas from '../images/elas.jpg'

function About() {
  useEffect(() => {
    scrollToTop()
  },[])
  
  return (
    <div className='min-h-screen bg-[#F5F1E9]'>
      {/* Hero Section */}
      <div className='relative'>
        <img 
          className='object-cover h-[22vh] min-h-[140px] sm:h-[26vh] md:h-[30vh] w-full' 
          src={bannerImage}
          alt="Ambiente acolhedor do Beauty Space"
        />
        <div className='absolute inset-0 bg-gradient-to-b from-[#c0a080]/40 to-[#c0a080]/70'></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <h2 className="text-[#F5F1E9] text-center px-6 text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-balance tracking-wide">
            Sobre Nós
          </h2>
        </div>
        
        {/* Wave shape at the bottom - Refinada */}
        <div className="absolute bottom-0 left-0 w-full h-16">
          <svg viewBox="0 0 1200 60" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="w-full h-full">
            <path d="M0,60 V30 C150,50 350,40 500,35 C650,30 750,25 900,30 C1050,35 1200,45 1200,45 V60 H0 Z" fill="#F5F1E9"/>
          </svg>
        </div>
      </div>
      
      {/* Nossa Equipe - Esteticistas Section */}
      <section className="py-16 md:py-20 px-6 reveal">
        <div className="container mx-auto max-w-5xl">
          
          {/* Primeira Esteticista */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-12 mb-16">
            <div className="w-full sm:w-72 md:w-1/3 flex justify-center shrink-0">
              {/* Polaroid Container */}
              <div className="relative group transition-transform duration-300 hover:scale-105 hover:rotate-0 -rotate-2 w-64 sm:w-72">
                {/* Washi Tape */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-20 h-5 bg-[#d2c2b0]/80 shadow-xs border border-white/40 -rotate-3 z-10 pointer-events-none"></div>
                
                {/* Polaroid Frame */}
                <div className="bg-white p-3 pb-5 shadow-lg border border-stone-200/60 rounded-xs">
                  <div className="overflow-hidden aspect-[4/5] bg-stone-100 mb-3">
                    <img 
                      src={maria}
                      className="w-full h-full object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-300" 
                      alt="Maria Lúcia" 
                    />
                  </div>
                  <div className="flex justify-between items-baseline px-1">
                    <span className="italic text-sm text-[#5c7160]">Maria Lúcia ♡</span>
                    <span className="text-[10px] uppercase tracking-wider text-[#a5bf99]">Esteticista</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Description Card */}
            <div className="w-full md:w-2/3 bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200/60 flex flex-col gap-4">
              <div>
                <h4 className="text-2xl font-light text-[#5c7160]">Maria Lúcia</h4>
                <p className="italic text-[#5c7160]/80">Esteticista</p>
              </div>
              
              <p className="text-base md:text-lg font-light text-[#5c7160] leading-relaxed">
                A Maria é uma profissional excecional, com anos de experiência técnica rigorosa em cada procedimento. Mas o que realmente a define é a sua energia contagiante: faz da sessão um momento descontraído e reconfortante. Focada no bem-estar integral e com uma empatia genuína (sobretudo pelo seu grande coração com o resgate animal), garante que cada visita termine com autoestima renovada e um sorriso largo.
              </p>
              
              <div className="w-32 h-0.5 bg-gradient-to-r from-transparent via-[#c0a080] to-transparent my-1"></div>
            </div>
          </div>
          
          {/* Segunda Esteticista */}
          <div className="flex flex-col md:flex-row-reverse items-center justify-center gap-10 md:gap-12">
            <div className="w-full sm:w-72 md:w-1/3 flex justify-center shrink-0">
              {/* Polaroid Container */}
              <div className="relative group transition-transform duration-300 hover:scale-105 hover:rotate-0 rotate-2 w-64 sm:w-72">
                {/* Washi Tape */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-20 h-5 bg-[#a5bf99]/50 shadow-xs border border-white/40 rotate-2 z-10 pointer-events-none"></div>
                
                {/* Polaroid Frame */}
                <div className="bg-white p-3 pb-5 shadow-lg border border-stone-200/60 rounded-xs">
                  <div className="overflow-hidden aspect-[4/5] bg-stone-100 mb-3">
                    <img 
                      src={lara}
                      className="w-full h-full object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-300" 
                      alt="Lara Almeida" 
                    />
                  </div>
                  <div className="flex justify-between items-baseline px-1">
                    <span className="italic text-sm text-[#5c7160]">Lara Almeida ✦</span>
                    <span className="text-[10px] uppercase tracking-wider text-[#a5bf99]">Esteticista</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Description Card */}
            <div className="w-full md:w-2/3 bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200/60 flex flex-col gap-4">
              <div>
                <h4 className="text-2xl font-light text-[#5c7160]">Lara Almeida</h4>
                <p className="italic text-[#5c7160]/80">Esteticista</p>
              </div>
              
              <p className="text-base md:text-lg font-light text-[#5c7160] leading-relaxed">
                Perfeccionista e artística, a Lara transforma qualquer cuidado de unhas ou epilação num trabalho de detalhe impecável. Tem um bom gosto natural para orientar tendências e formatos que combinam com a sua personalidade. Partilha da mesma sensibilidade e dedicação aos animais, trazendo uma leveza e elegância ao estúdio que faz o tempo passar sem dar por isso.
              </p>
              
              <div className="w-32 h-0.5 bg-gradient-to-r from-transparent via-[#c0a080] to-transparent my-1"></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Valores Section */}
      <section className="py-16 md:py-24 px-6 bg-[#f3f3eb] reveal">
        <div className="container mx-auto">
          <h3 className="text-3xl md:text-4xl font-light text-center text-[#415140] mb-12 relative">
            Os nossos valores
            <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-0.5 bg-[#a5bf99]"></span>
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="bg-white rounded-lg shadow-md p-8 transition-transform hover:-translate-y-1">
              <div className="w-16 h-16 rounded-full bg-[#a5bf99]/20 flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#5c7160]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h4 className="text-xl font-medium text-center text-[#415140] mb-4">Excelência</h4>
              <p className="text-[#415140]/80 text-center">
                Entregamos serviços de elevada qualidade, com rigor e atenção a cada pormenor, para realçar a sua verdadeira beleza.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-8 transition-transform hover:-translate-y-1">
              <div className="w-16 h-16 rounded-full bg-[#a5bf99]/20 flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#5c7160]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h4 className="text-xl font-medium text-center text-[#415140] mb-4">Cuidado</h4>
              <p className="text-[#415140]/80 text-center">
                Tratamos cada cliente como único, ouvindo atentamente e adaptando cada tratamento às suas necessidades pessoais.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-8 transition-transform hover:-translate-y-1">
              <div className="w-16 h-16 rounded-full bg-[#a5bf99]/20 flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#5c7160]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 className="text-xl font-medium text-center text-[#415140] mb-4">Bem-estar</h4>
              <p className="text-[#415140]/80 text-center">
                Acreditamos que a verdadeira beleza nasce do equilíbrio interior. Promovemos o seu bem-estar para um resultado harmonioso.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About